























import { defineComponent, PropType, ref, watch } from 'vue';

import { required } from '@/validators/validators';
import i18n from 'src/translate/lang';
import inputValidation from '@/validators/input-validation';

export default defineComponent({
  name: 'ListInputGender',
  props: {
    required: Boolean as PropType<boolean>,
    showError: Boolean as PropType<boolean>,
    value: {
      type: null,
    },
    label: {
      type: String as PropType<string>,
      default: () => i18n.t('global.fields.gender.label'),
    },
  },
  setup(props, context) {
    const gender = ref(props.value);

    const _props = {
      value: gender.value,
      name: 'gender',
      validation: {
        $autoDirty: true,
      },
    } as any;

    if (props.required) {
      _props.validation.required = required;
    }

    watch(
      () => props.value,
      (value: string) => {
        gender.value = value;
      },
    );

    const validation = inputValidation(_props, context);

    return {
      gender,
      ...validation,
    };
  },
  watch: {
    gender(value: string) {
      this.setValueRadio(value);
    },
  },
});
